export default "__VITE_ASSET__D2Axiy_H__"